import { user, user as authUser } from '@/ui/auth/auth';
import { InspectionQuery } from '@/services/api/resources/inspection/query';
import { Status, Type } from '@/entities/todo';

export const useQueries = () => {
  //based on filters present on the page
  const baseQuery = () => ({
    timezone: authUser.value.timezone,
    perPage: 3,
    page: 1,
    sort: '',
    dir: '',
    start: null,
    end: null,
    entityItem: [],
    group: [],
    user: [],
    category: [],
    checklist: [],
    section: [],
  });
  const recentlyDoneInspectionsQuery = (params = {}): InspectionQuery => ({
    ...baseQuery(),
    sort: 'doneAt',
    dir: 'desc',
    status: [Status.Done],
    type: Type.Inspection,
    lazyPagination: 1,
    assignee: [],
    updatedAtStart: null,
    updatedAtEnd: null,
    search: '',
    overdue: null,
    doneBy: [],
    categories: [],
    questionTitle: [],
    response: [],
    ...params,
  });
  const assignedToYouIssuesOrFormsQuery = (params = {}) => ({
    ...baseQuery(),
    sort: 'dueAt',
    dir: 'asc',
    updatedAtStart: null,
    updatedAtEnd: null,
    assignee: [user.value.id],
    issueStatus: [],
    priority: [],
    search: '',
    status: [Status.Pending],
    lazyPagination: 1,
    overdue: null,
    ...params,
  });
  const inProgressQuery = (params = {}) => ({
    ...baseQuery(),
    sort: 'dueAt',
    dir: 'asc',
    updatedAtStart: null,
    updatedAtEnd: null,
    assignee: [],
    assigneeOrInspectionUser: [user.value.id],
    issueStatus: [],
    priority: [],
    search: '',
    status: [Status.InProgress],
    lazyPagination: 0,
    overdue: null,
    ...params,
  });

  return {
    baseQuery,
    recentlyDoneInspectionsQuery,
    assignedToYouIssuesOrFormsQuery,
    inProgressQuery,
  };
};
